export const contactPagePath = '/contact'

export function contactPageUrl(subject?: string): string {
  if (!subject) return contactPagePath
  return `${contactPagePath}?subject=${encodeURIComponent(subject)}`
}
